import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ensureAuth } from '~/auth/utils';

export const Route = createFileRoute('/_authenticated')({
    beforeLoad: async ({ context: { auth } }) => {
        return ensureAuth(auth);
    },
    component: () => <Outlet />,
    head: () => ({
        meta: [{ name: 'robots', content: 'noindex' }],
    }),
});
